import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import OrderPage from './pages/OrderPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import TestPage from './pages/TestPage';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';

import '@mantine/core/styles.css';
// import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
// import '@mantine/dropzone/styles.css';
// import '@mantine/charts/styles.css';

// import 'mantine-datatable/styles.layer.css';

import './App.css';

import { Link } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import CongratulationsPage from './pages/CongratulationsPage';

// Mantine components for layout
import {
  AppShell,
  Text,
  Group,
  Button,
  Container,
  useMantineTheme,
  Stack,
} from '@mantine/core';

import '@mantine/notifications/styles.css';
import HeaderMenu from './components/Header';
import ThankYouPage from './pages/ThankYou';
import CardAnimations from './pages/Cards';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import PerformanceScreen from './pages/Performance';
import TermsAndService from './pages/TermsAndService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FreeTestPage from './pages/FreeTestPage';
import FAQSection from './components/FAQ';
import ContactPage from './pages/ContactUsPage';
import CommunityBoard from './pages/CommunityPage';
import { AdminTestConfig, AdminTestPage } from './pages/Admin/AdminPage';
import AdminPassagesPage from './pages/Admin/PassagesPage';
import { ExamResultsDetailPage, ExamResultsLayout, ExamResultsMainPage, ExamResultsProgressPage, ExamResultsQuestionPage } from './pages/ExamResultsPage';
import { CardsAdminLayout } from './pages/Admin/Cards';
import { ConverterLayout, ConverterMainPage, ConverterSettingsPage, ScoreHistoryPage } from './pages/Calculator';
import ResetPassword from './pages/ResetPassword';

const App: React.FC = () => {
  return (
    <>
      <div className="flex flex-col min-h-screen">
      <HeaderMenu />
      {/* <Header /> */}
      {/* The main content area for your routes */}
      <div className="flex flex-grow flex-col justify-between">
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        </Route>

        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/account-settings" element={<AccountSettingsPage />} />
          <Route path="/performance" element={<PerformanceScreen />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/test/:testId" element={<TestPage />} />
          <Route path="/tests" element={<ExamResultsLayout />}>
            {/* <Route index element={<ExamResultsMainPage />} /> */}
            <Route path="/tests/:testId" element={<ExamResultsDetailPage />} />
            <Route path="/tests/:testId/question/:questionId" element={<ExamResultsQuestionPage />} />
            <Route path="/tests/progress" element={<ExamResultsProgressPage />} />
          </Route>
          <Route path="/test-submitted/:testId" element={<CongratulationsPage />} />
          <Route path="/cards" element={<CardAnimations />} />

          <Route path="/admin" element={<PrivateRoute permissions={['Administrator']} />}>
            <Route path="/admin/passages" element={<AdminPassagesPage />} />
            <Route path="/admin/cards" element={<CardsAdminLayout />} />
            <Route path="/admin/tests" element={<AdminTestPage />} />
            <Route path="/admin/tests/:id" element={<AdminTestConfig />} />
          </Route>
        </Route>

        <Route path="/community/*" element={<CommunityBoard />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/faq" element={<FAQSection />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsAndService />} />
        <Route path="/free-test" element={<FreeTestPage />} />

        <Route path="/tools/lsat-calculator" element={<ConverterLayout />}>
          <Route path="history" element={<ScoreHistoryPage />} />
          <Route path="settings" element={<ConverterSettingsPage />} />
          <Route index element={<ConverterMainPage />} />
        </Route>

        {/* Catch-all or default route */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
      </div>
      <Footer />
      </div>
    </>
  );
};

export default App;
